<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-1 px-4"
      dense
      height="30"
    >
      <v-toolbar-title> {{ $t('history') }}</v-toolbar-title>
      <v-spacer />
      <export-excel
        :data="items"
        worksheet="abriron.com"
        name="data-ai.xlsx"
        class="float-left"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              icon
              small
              v-on="on"
            >
              <v-icon
                style="font-size: 22px"
                color="green"
              >
                mdi-file-excel-outline
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('excel') }}</span>
        </v-tooltip>
      </export-excel>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            class="float-left"
            small
            v-on="on"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
              @click="printDialog = true"
            >
              mdi-cloud-print-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('print') }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-row class="mx-0 mb-2">
      <v-col
        class=" px-2"
        cols="12"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('search')"
          solo
          flat
          height="30"
          :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
          dense
        />
      </v-col>
    </v-row>
    <v-col
      cols="12"
      class="px-2 pt-0"
    >
      <v-data-table
        v-if="headers"
        :height="tableHeight"
        fixed-header
        v-model="selected"
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        multi-sort
        dense
        :show-select="showSelect"
        item-key="id"
        class="mb-0"
      >
        <template v-slot:item.user="{ item }">
          {{ item.user.firstname }} ( {{ item.user.lastname }} )
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip
            v-if="item.status === 'active'"
            small
            color="blue"
            outlined
          >
            {{ $t('active') }}
          </v-chip>
          <v-chip
            v-if="item.lead === 'active'"
            small
            color="orange"
            class="mx-1"
            outlined
          >
            {{ $t('lead') }}
          </v-chip>
        </template>
        <template v-slot:item.doc_header.number="{ item }">
          <a
            v-if="item.doc_header"
            @click="documentPrint(item)"
          >
            {{ item.doc_header.number }}
          </a>
        </template>
        <template v-slot:item.id="{ item }">
          <a @click="edit(item)">
            {{ item.id }}
          </a>
        </template>
        <template v-slot:item.row="{ item }">
          <a @click="edit(item)">
            {{ parseInt(items.indexOf(item))+ parseInt(from) }}
          </a>
        </template>
        <template v-slot:item.tags="{ item }">
          <div class="pt-1">
            <v-chip
              v-for="(tag, index) in item.tags"
              :key="index"
              :color="tag.color"
              label
              small
              style="margin-left: 1px;margin-right:1px"
              class="px-1 mb-1"
              @click="edit(item)"
            >
              <span class="px-1 white--text">
                {{ tag.text }}
              </span>
            </v-chip>
          </div>
        </template>
        <template v-slot:item.remain="{ item }">
          {{ (item.remain ? $numberFormat(item.remain.remain) : 0) }}
          {{(item.remain && $store.state.currency.id !== item.remain.currency.id ? '(' + item.remain.currency_remain + '  ' + item.remain.currency.symbol + ')': '')}}
        </template>
        <template v-slot:item.currency="{ item }">
          {{item.currency.name}}
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip
            v-if="item.status"
            :color="item.color"
            label
            small
            class="px-1"
            outlined
          >
            <span class="px-2">
              {{ $t(item.status) }}
            </span>
          </v-chip>
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
      </v-data-table>
    </v-col>
    <v-row />
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="printDialog"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="printDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <print
            :header-prop="showHeaders"
            :items-prop="items"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="documentPrintDialog"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="documentPrintDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <documentPrint
            :id-prop="documentId"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-card>
</template>

<script>
  import Print from '../../components/general/Print/Index'
  import General from '../../../../Mixins/general'
  export default {
    name: 'SellList',
    components: {
      Snakbar: () => import('../../components/general/snakbar/snakbar'),
      documentPrint: () => import('../accounting/print'),
      Print,
    },
    mixins: [General],
    props: ['input', 'check'],
    data: () => ({
      selected: [],
      printDialog: false,
      documentPrintDialog: false,
      deletDialog: false,
      showSelect: false,
      filter: false,
      documentId: null,
      productStatus: null,
      productStatusItems: null,
      model: null,
      from: 1,
      taskDialog: null,
      tag: null,
      temp: null,
      deleteItem: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 0,
      snakbar: false,
      typeForm: null,
      id: null,
      snakbarText: null,
      loading: true,
      options: {
        itemsPerPage: 5,
      },
      headers: null,
      type: null,
      search: null,
    }),
    watch: {
      check (val, oldVal) {
        this.id = this.check.id
        if (this.id) {
          this.getItems()
        }
      },
      search () {
        var app = this
        app.loading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.getItems()
        }, 1000)
      },
      options: {
        handler () {
          var app = this
          app.sortBy = []
          app.options.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
          this.getItems()
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
    },
    beforeMount () {
      this.headers = [
        {
          text: this.$t('row'),
          align: 'start',
          sortable: false,
          value: 'row',
          width: 20,
        },
        {
          text: this.$t('content'),
          sortable: true,
          value: 'doc_header.content',
        },
        {
          text: this.$t('date'),
          sortable: false,
          value: 'date',
        },
        {
          text: this.$t('status'),
          sortable: true,
          value: 'status',
        },
        {
          text: this.$t('registerar'),
          sortable: false,
          value: 'user',
        },
        {
          text: this.$t('time'),
          sortable: false,
          value: 'time',
        },
      ]
    },
    mounted () {
      this.id = this.check.id
      if (this.id) {
        this.getItems()
      }
    },
    methods: {
      documentPrint (item) {
        this.documentId = item.doc_head_id
        this.documentPrintDialog = true
      },
      getItems () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'checks', {
          params: {
            statusTrack: true,
            id: app.id,
            search: app.search,
            page: app.options.page,
            refId: app.refId,
            type: app.type,
            sortBy: app.sortBy,
            status: app.productStatus,
            options: app.options,
            tag: app.tag,
            typeForm: app.typeForm,
          },
        })
          .then(res => {
            res = res.data
            app.items = res.data
            app.totalItems = res.total
            app.from = res.from
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
    },
  }
</script>

<style scoped>

</style>
